export const RECOMMENDATION_MODULES = {
    ECOMMERCE: "ECOMMERCE",
    MARKET: "MARKET",
};

export const RECOMMENDATION_CASES = {
    PRICE: { label: "Precio", modifier: "price", order: 0 },
    STOCK: { label: "Stock", modifier: "stock", order: 1 },
    MOVEMENT: { label: "Movimiento de precios", modifier: "movement", order: 2 },
};

export const sortRecommendationCards = (cards) =>
    [...cards].sort(
        (a, b) =>
            RECOMMENDATION_CASES[a.case].order - RECOMMENDATION_CASES[b.case].order
    );
